import Vue from 'vue'
import VueDraggableResizable from 'vue-draggable-resizable'
import VModal from 'vue-js-modal'
import Notifications from 'vue-notification'
import VueSmoothScroll from 'vue2-smooth-scroll'

import dayjs from 'dayjs'
import calendar from 'dayjs/plugin/calendar'
dayjs.extend(calendar)

import App from './App'
import SubmitButton from './components/tools/SubmitButton'
import LargeButton from './components/tools/LargeButton'
import { router } from './router/router'
import { store } from './store/store'

Vue.use(VModal)
Vue.use(Notifications)
Vue.use(VueSmoothScroll, {
    duration: 300,
    updateHistory: false,
})
Vue.component('vue-draggable-resizable', VueDraggableResizable)
Vue.component('SubmitButton', SubmitButton)
Vue.component('LargeButton', LargeButton)

Vue.config.productionTip = false

Vue.filter('formatDate', function(value) {
    if (value) {
        return dayjs(value).calendar()
    }
})

Vue.mixin({
    methods: {
        youtubeLinkToEmbed(link) {
            if (link.includes('/embed/')) {
                return link
            } else if (link.includes('watch')) {
                var regex = /(?:youtube\.com\/(?:[^/]+\/.+\/|(?:v|e(?:mbed)?)\/|.*[?&]v=)|youtu\.be\/)([^"&?/\s]{11})/gi
                let videoId = regex.exec(link)[1]
                return 'https://www.youtube.com/embed/'
                        +videoId
                        +'?playlist='
                        +videoId
                        +'&autoplay=1&mute=1&autohide=1&controls=0&loop=1&modestbranding=1&fs=0&autohide=0&disablekb=1'
            } else {
                this.warn('Unsupported youtube link. We\'ll try to display it anyway (can\'t promise anything though!)')
                return link
            }
        },
        openUrl(link) {
            window.open(link, '_blank')
        },
        notif(text, duration = 6000) {
            this.$notify({
                type: 'notify',
                text: text,
                duration: duration
            })
        },
        warn(text, duration = 10000) {
            this.$notify({
                type: 'warn',
                text: text,
                duration: duration
            })
        },
        error(text, duration = 10000) {
            this.$notify({
                type: 'error',
                text: text,
                duration: duration
            })
        }
    }
})
        
new Vue({
    router,
    render: (h) => h(App),
    store,
}).$mount('#app')